import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import screenOptions from '../config/screenOptions';
import {
  WorkerProfile, WorkerAlterPic,
  WorkerCoinBank, WorkerCoinClaim, WorkerClaimHistory, WorkerClaimSuccess,
  WorkerOnlineGym, WorkerOnlineGymDetails, WorkerOnlineGymEval,
  WorkerRecordedGym, WorkerInPersonGym, WorkerAlterPassword, AlterPersonalData,
} from '../screens/worker';

const Profile = createStackNavigator();
const ProfileWorker = () => (
  <Profile.Navigator screenOptions={screenOptions}>
    <Profile.Screen name="Worker Profile" component={WorkerProfile} />
    <Profile.Screen name="Worker Alter Pic" component={WorkerAlterPic} />
    <Profile.Screen name="Worker Alter Password" component={WorkerAlterPassword} />
    <Profile.Screen name="Worker Alter Data" component={AlterPersonalData} />

    <Profile.Screen name="Worker Coin Bank" component={WorkerCoinBank} />
    <Profile.Screen name="Worker Coin Claim" component={WorkerCoinClaim} />
    <Profile.Screen name="Worker Claim History" component={WorkerClaimHistory} />
    <Profile.Screen name="Worker Claim Success" component={WorkerClaimSuccess} />

    <Profile.Screen name="Worker Online Gym" component={WorkerOnlineGym} />
    <Profile.Screen name="Worker Recorded Gym" component={WorkerRecordedGym} />
    <Profile.Screen name="Worker InPerson Gym" component={WorkerInPersonGym} />

    <Profile.Screen name="Worker Online Gym Details" component={WorkerOnlineGymDetails} />
    <Profile.Screen name="Worker Online Gym Eval" component={WorkerOnlineGymEval} />
  </Profile.Navigator>
);

export default ProfileWorker;
